import React from 'react';
import { Images } from '../../app-constants';
import ImageIcon from './image-icon';

const MarkAsBounced = () => (
  <ImageIcon src={Images.MarkAsBounced} alt="Mark As Bounced" />
);

export default MarkAsBounced;
